import axios from "axios";

const getToken = () => window.localStorage.getItem("token");

export const defaultConfig = {
  baseURL: process.env.BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
  },
};

const httpClient = axios.create(defaultConfig);

httpClient.interceptors.request.use((config) => {
  config.headers["X-Authorization"] = `Bearer ${getToken()}`;
  return config;
});

export default httpClient;



// WEBPACK FOOTER //
// ./src/_shared/http-client.js